'use client';
import React, { useState, useCallback } from 'react';
import FAIcons from '../../utils/icons';
import debounce from 'lodash/debounce';
import styles from './IconPicker.module.css';

export default function IconPicker({ handleIcon, prevIcon }) {
    const [iconArr, setIconArr] = useState(FAIcons);
    const [currentIcon, setCurrentIcon] = useState(prevIcon);
    const handleSearch = useCallback(
        debounce((e) => {
            const value = e.target.value.toLowerCase();

            setIconArr(value ? FAIcons.filter(icon => icon.includes(value)) : FAIcons);
        },100)
        ,[]
    );

    const handleClear = () => {
        const input = document.querySelector(`.${styles.input}`);
        input.value = '';
        setIconArr(FAIcons);
    };

    const handleIconTrigger = (e) => {
        const icon = e.target.getAttribute('data-value');
        setCurrentIcon(icon);
        handleIcon(icon);
    };

    return (
        <div className={styles.container}>
            <div className={styles.icon}>{currentIcon ? <i className={currentIcon} aria-hidden /> : currentIcon === '' ? <span>None</span> : <span>Select Icon</span>}</div>
            <div className={styles.wrap}>
                <div className={styles.inputWrap}>
                    <input type='text' className={styles.input} placeholder='Search Icons' onChange={handleSearch} />
                    <button className={styles.inputClear} onClick={handleClear}>Clear</button>
                </div>
                <div className={styles.select}>
                    <div data-id='icon' className={currentIcon === '' ? `${styles.iconItem} ${styles.active}` : styles.iconItem} data-value='' onClick={handleIconTrigger} >
                        <i className='fas fa-ban' aria-hidden style={{pointerEvents: 'none', color: '#bbb'}} />
                    </div>
                    {iconArr.map((icon, index) => (
                        <div key={index} data-id='icon' className={icon === currentIcon ? `${styles.iconItem} ${styles.active}` : styles.iconItem} data-value={icon} onClick={handleIconTrigger}>
                            <i className={icon} aria-hidden style={{pointerEvents: 'none'}} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};